import { render, staticRenderFns } from "./NormalSearchNav162.vue?vue&type=template&id=2b35fdcf&scoped=true"
import script from "./NormalSearchNav162.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav162.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35fdcf",
  null
  
)

export default component.exports